import { render } from "./MediaBody.vue?vue&type=template&id=1cfbfb96"
import script from "./MediaBody.vue?vue&type=script&lang=js"
export * from "./MediaBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Layout/MediaBody.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1cfbfb96"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1cfbfb96', __exports__)) {
    api.reload('1cfbfb96', __exports__)
  }
  
  module.hot.accept("./MediaBody.vue?vue&type=template&id=1cfbfb96", () => {
    api.rerender('1cfbfb96', render)
  })

}


export default __exports__